import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe, User } from "lucide-react";
import { ECOSYSTEM, CONTACT, FOOTER_NAV, SOCIALS } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="relative bg-oxford text-white overflow-hidden">
      <img src="/brand/isotipo-gold.webp" alt="" className="absolute -right-24 -top-24 w-[420px] opacity-[0.05] pointer-events-none" />
      <span className="absolute top-0 left-0 right-0 h-px gold-hairline" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-4">
              <img src="/brand/isotipo-gold.webp" alt="" className="h-14 w-auto" />
              <span className="flex flex-col items-start gap-1.5">
                <img src="/brand/brik-white.webp" alt="BRIK" className="h-7 w-auto" />
                <span className="font-display text-[10px] font-semibold tracking-[0.42em] uppercase text-steel">Procurement Partners</span>
              </span>
            </div>
            <p className="mt-6 font-display text-sm font-semibold tracking-wide">
              <span className="text-white">Better Buying.</span> <span className="text-gold">Better Business.</span>
            </p>
            <p className="mt-4 text-sm leading-relaxed text-steel max-w-xs">
              Construimos capacidades de Procurement que convierten Compras en una ventaja competitiva.
            </p>
            <div className="mt-7 flex items-center gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.id}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.id}`}
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center border border-white/15 text-steel transition-all duration-300 hover:border-gold hover:text-gold"
                >
                  <s.icon className="h-4 w-4" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-display text-sm font-semibold tracking-[0.22em] uppercase text-gold">BRIK</h3>
            <ul className="mt-6 space-y-3">
              {FOOTER_NAV.map((l) => (
                <li key={l.id}>
                  <Link to={l.path} data-testid={`footer-link-${l.id}`} className="text-sm text-steel hover:text-gold transition-colors duration-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-display text-sm font-semibold tracking-[0.22em] uppercase text-gold">Divisiones</h3>
            <ul className="mt-6 space-y-3">
              {ECOSYSTEM.map((d) => (
                <li key={d.name}>
                  <Link to="/divisiones" data-testid={`footer-division-${d.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-sm text-steel hover:text-gold transition-colors duration-300">
                    {d.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-display text-sm font-semibold tracking-[0.22em] uppercase text-gold">Contacto</h3>
            <ul className="mt-6 space-y-4 text-sm text-steel">
              <li className="flex items-center gap-3">
                <User className="h-4 w-4 text-gold shrink-0" strokeWidth={1.5} /> {CONTACT.founder}
              </li>
              <li>
                <a href={`tel:${CONTACT.phoneHref}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-gold transition-colors">
                  <Phone className="h-4 w-4 text-gold shrink-0" strokeWidth={1.5} /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-gold transition-colors">
                  <Mail className="h-4 w-4 text-gold shrink-0" strokeWidth={1.5} /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Globe className="h-4 w-4 text-gold shrink-0" strokeWidth={1.5} /> {CONTACT.website}
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-gold shrink-0" strokeWidth={1.5} /> {CONTACT.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <p className="text-xs text-steel">© 2026 BRIK Procurement Partners. Todos los derechos reservados.</p>
            <Link to="/aviso-de-privacidad" data-testid="footer-privacy-link" className="text-xs text-steel underline-offset-4 transition-colors duration-300 hover:text-gold hover:underline">
              Aviso de Privacidad
            </Link>
          </div>
          <p className="font-display text-[10px] font-semibold tracking-[0.35em] uppercase text-steel">
            Procurement <span className="text-gold mx-1">—</span> Strategy <span className="text-gold mx-1">—</span> Execution
          </p>
        </div>
      </div>
    </footer>
  );
}
